<template>
    <div class="content-wraper">
        <div class="container">
            <div class="account-dashboard mtb-60">
                <div class="dashboard-upper-info">
                    <div class="row align-items-center no-gutters">
                        <div class="col-lg-3 col-md-12">
                            <div class="d-single-info">
                                <p class="user-name">Hallo <span>{{ this.$store.getters.user.FirstName }} </span></p>
                                <small>
                                    Ben je niet {{ this.$store.getters.user.FirstName }} ?
                                    <br>
                                    <router-link :to="{name: 'logout'}">Uitloggen</router-link>
                                </small>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="d-single-info">
                                <p><strong>Hulp nodig?</strong> Neem contact op met ons via:</p>
                                <p><a href="mailto:uitleendienst@faro.be">uitleendienst@faro.be</a></p>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                            <!-- <div class="d-single-info text-lg-center">
                                <router-link class="view-cart" :to="{ name: 'cart' }">Mijn Winkelwagen</router-link>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-2">
                        <!-- Nav tabs -->
                        <ul
                        class="nav flex-column dashboard-list"
                        role="tablist">
                            <li>
                                <a
                                    class="nav-link active show"
                                    data-toggle="tab"
                                    href="#dashboard">Mijn gegevens
                                </a>
                            </li>
                            <li>
                                <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#reserveringen">
                                    Reserveringen
                                </a>
                            </li>
                            <li>
                                <router-link
                                    :to="{name: 'logout'}"
                                    class="nav-link">
                                        Uitloggen
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-12 col-lg-10">
                        <!-- Tab panes -->
                        <div class="tab-content dashboard-content">
                            <div
                            id="dashboard"
                            class="tab-pane fade active show">
                                <h3>Mijn gegevens</h3>
                                <p>
                                    Voeg hieronder je contactgegevens toe om materiaal te kunnen reserveren en ontlenen.
                                </p>
                                <br>
                                <p>
                                    Je persoonlijke gegevens worden beheerd volgens het <a href="https://faro.be/privacybeleid">Privacybeleid van FARO</a>.
                                    Ze worden alleen gebruikt om onze dienstverlening aan jou zo vlot mogelijk te organiseren.
                                    Dit houdt in dat we de gegevens delen met de partnerorganisaties die een uitleenpunt bemannen.
                                    Je kunt je persoonlijke gegevens op elk moment inkijken, bewerken en verwijderen, nadat je bent ingelogd.
                                    Of je kunt een aanvraag richten aan <a href="mailto:uitleendienst@faro.be">uitleendienst@faro.be</a>.
                                </p>
                                <hr>
                                <UserDetails />
                            </div>
                            <div
                            id="reserveringen"
                            class="tab-pane fade">
                                <h3>Reserveringen</h3>
                                <ReservationsTable />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserDetails from './UserDetails'
import ReservationsTable from './ReservationsTable'

export default {
    components: {
        ReservationsTable,
        UserDetails
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/Index.vue